import { render, staticRenderFns } from "./pwaIosPopup.vue?vue&type=template&id=764cdb15&scoped=true"
import script from "./pwaIosPopup.vue?vue&type=script&lang=js"
export * from "./pwaIosPopup.vue?vue&type=script&lang=js"
import style0 from "./pwaIosPopup.vue?vue&type=style&index=0&id=764cdb15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764cdb15",
  null
  
)

export default component.exports